import { render, staticRenderFns } from "./EstimatedMargins.vue?vue&type=template&id=5d3b9fec&"
import script from "./EstimatedMargins.vue?vue&type=script&lang=js&"
export * from "./EstimatedMargins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports